import type { RigListQuery } from '@chukua/common';
import { Segmented } from 'antd';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import { activeUnitPreset, UNIT_PRESETS, type UnitPresetKey } from '../policies/unit-presets';

/** One-click presets over `kind` and `deactivated`: every unit, coupled, trucks with no trailer, spare and deactivated trailers. */
export function UnitPresets({ list }: { list: Pick<ListQueryControls<RigListQuery>, 'query' | 'setQuery'> }) {
  const active = activeUnitPreset(list.query);
  return (
    <Segmented<UnitPresetKey | 'custom'>
      aria-label="Show"
      value={active ?? 'custom'}
      options={[
        ...UNIT_PRESETS.map(({ key, label }) => ({ value: key, label })),
        ...(active ? [] : [{ value: 'custom' as const, label: 'Custom', disabled: true }]),
      ]}
      onChange={(key) => {
        const preset = UNIT_PRESETS.find((candidate) => candidate.key === key);
        if (preset) list.setQuery({ kind: preset.kinds, deactivated: preset.deactivated });
      }}
    />
  );
}
